import script from "./StoreNew.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreNew.vue?vue&type=script&setup=true&lang=js"

import "./StoreNew.vue?vue&type=style&index=0&id=25d42754&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25d42754"]])

export default __exports__